import Widgets from 'js-widget-hooks';
import $ from '../../util/jQuery';
import {debounce} from "underscore";

const MIN_SEARCH_CHARACTER_LENGTH = 3;
const DEBOUNCE_TIME_MS = 200;

const runAjax = function (query, callback) {
    $.get('/api/geo-suggestions.php?query=' + encodeURIComponent(query), function (res) {
        callback(res);
    })
};

const lazyAjax = debounce(runAjax, DEBOUNCE_TIME_MS);

const highlight = function (text, toHighlight) {
    const regex = new RegExp(toHighlight, 'gi');
    return text.trim().replace(regex, match => `<strong>${match}</strong>`);
}

Widgets.register('search-suggestion-input', function (el) {

    let currentId = 0;
    let currentVal = '';
    let currentSuggestions = [];

    const elem = $(el);
    const input = elem.find('.trigger-search');
    const form = elem.closest('form');
    const placeIdInput = form.find('#placeId');
    const latInput = form.find('#lat');
    const lonInput = form.find('#lon');

    const therapistInput = elem.parent().find('#stherapeut');

    /**
     *
     * @param {{id: string, label: string}} suggestion
     */
    const submitPlace = function (suggestion) {
        placeIdInput.val(suggestion.id);
        input.val(suggestion.label);

        input.addClass('loading');
        elem.find('.search-suggestions').remove();

        $.get('/api/geo-details.php?placeId=' + encodeURIComponent(suggestion.id), function (res) {
            const geo = res.features[0].geometry.coordinates
            lonInput.val(geo[0]);
            latInput.val(geo[1]);
            form.submit();
        })
    }

    if (therapistInput.val()) {
        elem.hide();
    }

    therapistInput.on('change', () => {
        if (therapistInput.val()) {
            elem.hide();
        } else {
            elem.show();
        }
    });

    form.on('submit', function (e) {
        input.removeClass('error');
        const values = Object.fromEntries(new FormData(form[0]));

        if (!values.placeId && !therapistInput.val()) {
            e.preventDefault();
            if (currentSuggestions.length) {
                const theId = currentId < currentSuggestions.length ? currentId : 0;

                submitPlace(currentSuggestions[theId]);
            } else {
                input.addClass('error');
            }
        }
    });

    const markSuggestion = function (index) {
        $(elem.find('.search-suggestions li').removeClass('focus')[index]).addClass('focus');
    };

    input.on('keydown', function (e) {
        const keyCode = e.originalEvent.keyCode;

        switch (keyCode) {
            case 13:
                e.preventDefault();
                e.stopPropagation();

                submitPlace(currentSuggestions[currentId]);
                break;
            case 38: // arrow up
                e.preventDefault();
                e.stopPropagation();
                currentId = currentId - 1 < 0 ? (currentSuggestions.length ? currentSuggestions.length - 1 : 0) : currentId - 1;
                markSuggestion(currentId);
                break;
            case 40: // arrow down
                e.preventDefault();
                e.stopPropagation();
                currentId = currentId + 1 >= currentSuggestions.length ? 0 : currentId + 1;
                markSuggestion(currentId);
                break;
        }

    });

    input.on('keyup click', function (e) {

        const keyCode = e.originalEvent.keyCode;

        // arrow up, arrow down
        if (keyCode === 38 || keyCode === 40) {
            e.preventDefault();
            e.stopPropagation();
        }

        const newVal = $(this).val();

        if (newVal !== currentVal) {
            currentVal = newVal;

            if (newVal.length >= MIN_SEARCH_CHARACTER_LENGTH) {

                input.addClass('loading');
                lazyAjax(newVal, function (suggestionResult) {
                    input.removeClass('loading');

                    const suggestions = Array.isArray(suggestionResult.geo) ? suggestionResult.geo : [];
                    const therapists = suggestionResult.therapists;

                    currentSuggestions = suggestions;
                    currentId = 0;
                    placeIdInput.val('');

                    elem.find('.search-suggestions').remove();
                    elem.append('<ul class="search-suggestions">' + suggestions.map(function (s) {
                            return `<li data-id="${s.id}"><span>${highlight(s.label, newVal)}</span></li>`
                        }).join('') +

                        (Array.isArray(therapists) && therapists.length ? '<li class="search-suggestions__seperator"></li>' + therapists.map((t) => {
                            return `<li class="js-therapist"><a href="/therapeuten_detail.php?id=${t.id}" class="search-suggestions__link">${t.title} ${highlight(t.firstname, newVal)} ${highlight(t.lastname, newVal)}${t.praxis ? ', ' + highlight(t.praxis, newVal) : ''}</a></li>`;
                        }).join('') : '') +
                        '</ul>'
                    );

                    markSuggestion(currentId);

                    elem.find('.search-suggestions li').on('click', function () {
                        submitPlace({id: $(this).data('id'), label: $(this).text()});
                    });
                });
            } else {
                elem.find('.search-suggestions').remove();
                currentSuggestions = [];
                currentId = 0;
                placeIdInput.val('');
            }
        }
    })
});